import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BoxComponent } from '../common/box/box.component';
import { PlaceloaderComponent } from '../common/placeloader/placeloader.component';

@Component({
  selector: 'rt-box-placeloader',
  templateUrl: 'box-placeloader.component.html',
  styleUrls: ['box-placeloader.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.stacked]': 'stacked',
  },
  standalone: true,
  imports: [BoxComponent, PlaceloaderComponent, NgIf],
})
export class BoxPlaceloaderComponent {
  @Input() public onlyOnePlaceloader: boolean = false;
  @Input() public height: number = 0;
  @Input() public stacked: boolean;
}
